import Pagination from "@material-tailwind/react/Pagination";
import PaginationItem from "@material-tailwind/react/PaginationItem";
import Icon from "@material-tailwind/react/Icon";

export default function PaginationComponent({numPages, currentPage, setCurrentPage}) {
    return (
        <Pagination>
            <PaginationItem className="cursor-pointer" button ripple="dark" onClick={() => setCurrentPage(0)}>
                First
            </PaginationItem>
            <PaginationItem className="cursor-pointer" ripple="dark" onClick={currentPage !== 0 ? () => setCurrentPage(currentPage - 1) : _ => {}}>
                <Icon name="keyboard_arrow_left" />
            </PaginationItem>
            {[...Array(numPages)].map((_, i) => (
                <PaginationItem key={i} className="cursor-pointer" onClick={() => setCurrentPage(i)} color={currentPage === i ? "gray" : ""} ripple="light">{i + 1}</PaginationItem>
            ))}
            <PaginationItem className="cursor-pointer" ripple="dark" onClick={currentPage !== (numPages - 1) ? () => setCurrentPage(currentPage + 1) : _ => {}}>
                <Icon name="keyboard_arrow_right" />
            </PaginationItem>
            <PaginationItem className="cursor-pointer" button ripple="dark" onClick={() => setCurrentPage(numPages - 1)}>
                Last
            </PaginationItem>
        </Pagination>
    );
}